import type { Align, Shape, Theme } from '../../types/props.js'
import type { MultiLayoutGraphicBlockProps } from '../MultiLayoutGraphicBlock/types.js'
import type { ShelfDisplayProps } from '../ShelfDisplay/shelfDisplay.js'
import type { AccordionCardsType } from '../AccordionCards/index.js'
import type { FaqProps } from '../Faq/types.js'
import type { GraphicProps } from '../Graphic/index.js'
import type { WhyChooseProps } from '../WhyChoose/types.js'
import type { BrandEquityProps } from '../BrandEquity/types.js'
import type { BrandCardLinkProps } from '../BrandCardLink/types.js'

export type TabsProps = {
  data: {
    sectionTitle?: string
    theme: Theme
    shape: Shape
    align: Align
    tabs: {
      id: string
      tabName: string
      tabContent:
        | (ShelfDisplayProps['data'] & { blockType: 'ipc-shelfdisplay' })[]
        | (MultiLayoutGraphicBlockProps['data'] & { blockType: 'ipc-multiLayoutGraphicBlock' })[]
        | (AccordionCardsType['data'] & { blockType: 'ipc-accordioncards' })[]
        | (FaqProps['data'] & { blockType: 'ipc-faq' })[]
        | (GraphicProps['data'] & { blockType: 'ipc-graphic' })[]
        | (WhyChooseProps['data'] & { blockType: 'ipc-whychoose' })[]
        | (BrandEquityProps['data'] & { blockType: 'ipc-brand-equity' })[]
        | (BrandCardLinkProps['data'] & { blockType: 'ipc-brand-card-link' })[]
    }[]
  }
  className?: string
}
